// import React, { useEffect, useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import IconButton from "@mui/material/IconButton";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
// import PersonSearchTwoToneIcon from "@mui/icons-material/PersonSearchTwoTone";
// import WorkTwoToneIcon from "@mui/icons-material/WorkTwoTone";
// import EventTwoToneIcon from "@mui/icons-material/EventTwoTone";
// import CalendarTodayTwoToneIcon from "@mui/icons-material/CalendarTodayTwoTone";
// import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
// import KeyboardDoubleArrowLeftSharpIcon from "@mui/icons-material/KeyboardDoubleArrowLeftSharp";
// import { Collapse, Tooltip, Stack } from "@mui/material";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import MuiAppBar from "@mui/material/AppBar";
// import { tooltipClasses } from "@mui/material/Tooltip";
// import LogoutIcon from "@mui/icons-material/Logout";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logout } from "../../../Redux/slices/authSlice";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import HRcandidate from "../HRcandidate";
// import HRTable from "../HRcandidate/HRTable";
// import createInstance from "../../../api/axiosinstance";
// import JobDescription from "../../organization/JobDescription";
// import JobDescriptionManagementList from "../../organization/JobDescriptionManagementList";
// import ScheduleInterview from "../ScheduleInterview";
// import InterviewsTable from "../InterviewsTable";
// import ZoomMeeting from "../Zoom";

// const drawerWidth = 300;

// const openedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   backgroundColor: "#1E1E1E",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   borderRadius: 10,
//   backgroundColor: "#1E1E1E",
//   marginTop: 15,
//   marginRight: 20,
//   width: `calc(100% - 7%)`,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     width: `calc(100% - ${drawerWidth + 40}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

// const HRLandingPage = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("HR Dashboard");
//   const dispatch = useDispatch();
//   const userName = CapitalizeName(user?.name || "");
//   const navigate = useNavigate();
//   const aiDisha = createInstance("DISHA");
//   const organizationId = user?.organizationId;
//   const [showCreateNewJob, setShowCreateNewJob] = useState(false);
//   const [showScheduleInterview, setShowScheduleInterview] = useState(false);

//   useEffect(() => {
//     Dashboard();
//   }, []);

//   const handleOpenCreateNewJob = () => {
//     setMenudata("");
//     setTitleText("Create New Job");
//     setShowCreateNewJob(true);
//     setShowScheduleInterview(false);
//   };

//   const handleOpenScheduleInterview = () => {
//     setMenudata("");
//     setTitleText("Schedule Interview");
//     setShowScheduleInterview(true);
//     setShowCreateNewJob(false);
//   };

//   const handleCloseScheduleInterview = () => {
//     setShowScheduleInterview(false);
//     setMenudata("Dashboard");
//     setTitleText("HR Dashboard");
//   };

//   const Dashboard = async () => {
//     try {
//       const response = await aiDisha.get(
//         `/hr_dashboard?organization_id=${organizationId}`
//       );
//       console.log("dashboard", response.data);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   const icons = [
//     HomeTwoToneIcon,
//     PersonSearchTwoToneIcon,
//     WorkTwoToneIcon,
//     EventTwoToneIcon,
//     CalendarTodayTwoToneIcon, // Added for Interviews
//   ];

//   const handleListItemClick = (item) => {
//     setMenudata(item);
//     setTitleText(item === "Dashboard" ? "HR Dashboard" : item);
//     setShowCreateNewJob(false);
//     setShowScheduleInterview(false);
//   };

//   const [open, setOpen] = useState(false);

//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const [openIndex, setOpenIndex] = useState(null);
//   const handleItemClick = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const handleLogOut = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   if (!isAuthenticated || user?.role !== "HR") {
//     navigate("/");
//     return null;
//   }

//   return (
//     <Box sx={{ display: "flex", backgroundColor: "white", height: "100vh" }}>
//       <AppBar position="fixed" open={open} sx={{ background: "#006A71" }}>
//         <Toolbar>
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography
//               variant="h5"
//               color="white"
//               sx={{ fontSize: "25px", textAlign: "left" }}
//             >
//               {titleText}
//             </Typography>
//           </Box>
//         </Toolbar>
//       </AppBar>
//       <Drawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ position: "relative" }}>
//           <Box
//             sx={{
//               backgroundColor: "white",
//               width: "100%",
//               height: "77%",
//               marginTop: "5%",
//               marginRight: "30px",
//               borderRadius: "10px 30px 0px 20px",
//               position: "relative",
//             }}
//           >
//             {isAuthenticated && (
//               <LightTooltip title={`${user?.name || ""}`} placement="right">
//                 <Typography
//                   sx={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "20px",
//                     transform: "translateY(-50%)",
//                     fontSize: "15px",
//                     fontWeight: "bold",
//                     color: "#1E1E1E",
//                     maxWidth: "160px",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                     display: open ? "block" : "none",
//                   }}
//                 >
//                   Welcome {userName}
//                 </Typography>
//               </LightTooltip>
//             )}
//           </Box>
//         </DrawerHeader>
//         <DrawerHeader>
//           <IconButton
//             color="white"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{
//               color: "white",
//               marginRight: 1,
//               marginLeft: 1,
//             }}
//           >
//             {open ? (
//               <KeyboardDoubleArrowLeftSharpIcon />
//             ) : (
//               <KeyboardDoubleArrowRightSharpIcon />
//             )}
//           </IconButton>
//         </DrawerHeader>

//         <List sx={{ color: "white" }}>
//           {[
//             "Dashboard",
//             "Candidate FeedBack",
//             "Manage Jobs",
//             "Schedule Interview",
//             "Interviews",
//             "Zoom Records"
//           ].map((text, index) => (
//             <React.Fragment key={text}>
//               <ListItem
//                 disablePadding
//                 onClick={() => {
//                   if (text === "Schedule Interview") {
//                     handleOpenScheduleInterview();
//                   } else {
//                     handleListItemClick(text);
//                   }
//                 }}
//               >
//                 <ListItemButton onClick={() => handleItemClick(index)}>
//                   <ListItemIcon sx={{ color: "white" }}>
//                     <LightTooltip title={text}>
//                       {React.createElement(icons[index % icons.length])}
//                     </LightTooltip>
//                   </ListItemIcon>
//                   <ListItemText primary={text} />
//                 </ListItemButton>
//               </ListItem>
//             </React.Fragment>
//           ))}
//         </List>
//         <DrawerHeader>
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{
//               color: "white",
//               marginRight: 1,
//             }}
//           >
//             <Stack direction="column" spacing={1}>
//               {open ? (
//                 <KeyboardDoubleArrowLeftSharpIcon />
//               ) : (
//                 <KeyboardDoubleArrowRightSharpIcon />
//               )}
//               {isAuthenticated && (
//                 <div onClick={handleLogOut} title="Logout">
//                   <LogoutIcon />
//                 </div>
//               )}
//             </Stack>
//           </IconButton>
//         </DrawerHeader>
//       </Drawer>
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           minHeight: "100vh",
//           backgroundColor: "white",
//           overflow: "auto",
//         }}
//       >
//         <DrawerHeader />
//         {menudata === "Dashboard" && <HRcandidate />}
//         {menudata === "Candidate FeedBack" && <HRTable />}
//         {menudata === "Manage Jobs" && (
//           <JobDescriptionManagementList
//             onOpenJobDescription={handleOpenCreateNewJob}
//           />
//         )}
//         {showCreateNewJob && <JobDescription />}
//         {showScheduleInterview && (
//           <ScheduleInterview onClose={handleCloseScheduleInterview} />
//         )}
//         {menudata === "Interviews" && <InterviewsTable />}
//         {menudata === "Zoom Records" && <ZoomMeeting />}
//       </Box>
//     </Box>
//   );
// };

// export default HRLandingPage;































// import React, { useEffect, useState } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Drawer as MuiDrawer,
//   AppBar as MuiAppBar,
//   Toolbar,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Typography,
//   Stack,
//   Tooltip,
//   Avatar,
//   Menu,
//   MenuItem,
//   Divider,
//   Card,
//   CardContent,
// } from "@mui/material";
// import {
//   Menu as MenuIcon,
//   ChevronLeft as ChevronLeftIcon,
//   Home as HomeIcon,
//   Person as PersonIcon,
//   Work as WorkIcon,
//   Event as EventIcon,
//   CalendarMonth as CalendarIcon,
//   Videocam  as VideoIcon,
//   Logout as LogoutIcon,
//   ExpandMore as ExpandMoreIcon,
//   Fullscreen as FullscreenIcon,
//   ArrowBack as ArrowBackIcon,
// } from "@mui/icons-material";
// // import COLORS from "../../Themes/Colours";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";

// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logout } from "../../../Redux/slices/authSlice";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import createInstance from "../../../api/axiosinstance";

// // Components
// import HRcandidate from "../HRcandidate";
// import HRTable from "../HRcandidate/HRTable";
// import JobDescription from "../../organization/JobDescription";
// import JobDescriptionManagementList from "../../organization/JobDescriptionManagementList";
// import ScheduleInterview from "../ScheduleInterview";
// import InterviewsTable from "../InterviewsTable";
// import ZoomMeeting from "../Zoom";

// const drawerWidth = 300;

// // ==================== STYLED COMPONENTS ====================
// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const StyledDrawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...openedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...closedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
// }));

// const StyledAppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   background: COLORS.primary,
//   borderBottom: `1px solid ${COLORS.border}`,
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// // ==================== MAIN COMPONENT ====================
// const HRLandingPage = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const aiDisha = createInstance("DISHA");
//   const organizationId = user?.organizationId;
//   const userName = CapitalizeName(user?.name || "");
//   const { COLORS } = useThemeMode();
  

//   // State Management
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("HR Dashboard");
//   const [open, setOpen] = useState(true);
//   const [showCreateNewJob, setShowCreateNewJob] = useState(false);
//   const [showScheduleInterview, setShowScheduleInterview] = useState(false);
//   const [profileAnchor, setProfileAnchor] = useState(null);

//   // Menu Configuration
//   const menuItems = [
//     { label: "Dashboard", icon: HomeIcon, key: "Dashboard" },
//     { label: "Candidate Feedback", icon: PersonIcon, key: "Candidate FeedBack" },
//     { label: "Manage Jobs", icon: WorkIcon, key: "Manage Jobs" },
//     { label: "Schedule Interview", icon: EventIcon, key: "Schedule Interview" },
//     { label: "Interviews", icon: CalendarIcon, key: "Interviews" },
//     { label: "Zoom Records", icon: VideoIcon, key: "Zoom Records" },
//   ];

//   // Fetch Dashboard Data
//   useEffect(() => {
//     Dashboard();
//   }, [organizationId]);

//   const Dashboard = async () => {
//     try {
//       const response = await aiDisha.get(
//         `/hr_dashboard?organization_id=${organizationId}`
//       );
//       console.log("dashboard", response.data);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   // Event Handlers
//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const handleListItemClick = (item) => {
//     if (item === "Schedule Interview") {
//       handleOpenScheduleInterview();
//     } else {
//       setMenudata(item);
//       setTitleText(item === "Dashboard" ? "HR Dashboard" : item);
//       setShowCreateNewJob(false);
//       setShowScheduleInterview(false);
//     }
//   };

//   const handleOpenCreateNewJob = () => {
//     setMenudata("");
//     setTitleText("Create New Job");
//     setShowCreateNewJob(true);
//     setShowScheduleInterview(false);
//   };

//   const handleOpenScheduleInterview = () => {
//     setMenudata("");
//     setTitleText("Schedule Interview");
//     setShowScheduleInterview(true);
//     setShowCreateNewJob(false);
//   };

//   const handleCloseScheduleInterview = () => {
//     setShowScheduleInterview(false);
//     setMenudata("Dashboard");
//     setTitleText("HR Dashboard");
//   };

//   const handleProfileMenuOpen = (event) => {
//     setProfileAnchor(event.currentTarget);
//   };

//   const handleProfileMenuClose = () => {
//     setProfileAnchor(null);
//   };

//   const handleLogOut = () => {
//     handleProfileMenuClose();
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   const handleFullscreen = () => {
//     if (
//       document.fullscreenElement ||
//       document.webkitFullscreenElement ||
//       document.msFullscreenElement
//     ) {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       } else if (document.webkitExitFullscreen) {
//         document.webkitExitFullscreen();
//       } else if (document.msExitFullscreen) {
//         document.msExitFullscreen();
//       }
//     } else {
//       const element = document.documentElement;
//       if (element.requestFullscreen) {
//         element.requestFullscreen();
//       } else if (element.webkitRequestFullscreen) {
//         element.webkitRequestFullscreen();
//       } else if (element.msRequestFullscreen) {
//         element.msRequestFullscreen();
//       }
//     }
//   };

//   if (!isAuthenticated || user?.role !== "HR") {
//     navigate("/");
//     return null;
//   }

//   return (
//     <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
//       {/* AppBar */}
//       <StyledAppBar position="fixed" open={open}>
//         <Toolbar sx={{ minHeight: "70px", display: "flex", justifyContent: "space-between" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <IconButton
//               color="inherit"
//               aria-label="toggle drawer"
//               onClick={handleDrawerToggle}
//               edge="start"
//               sx={{ color: COLORS.accent }}
//             >
//               {open ? <ChevronLeftIcon /> : <MenuIcon />}
//             </IconButton>

//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{
//                 fontSize: "20px",
//                 fontWeight: 600,
//                 color: COLORS.text,
//                 letterSpacing: "0.5px",
//               }}
//             >
//               {titleText}
//             </Typography>
//           </Box>

//           {/* Right Side Actions */}
//           <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            
            
//             <Toolbar sx={{ justifyContent: "flex-end" }}>
//                           <IconButton
//                             onClick={toggleTheme}
//                             sx={{
//                               color: COLORS.text,
//                               "&:hover": { background: COLORS.hoverBg },
//                             }}
//                           >
//                             {theme === "light" ? <DarkModeIcon /> : <LightModeIcon />}
//                           </IconButton>
//                         </Toolbar>
            
            
            
            
            
            
            
            
            
            
            
//             <Tooltip title="Fullscreen Mode (F11)">
//               <IconButton
//                 onClick={handleFullscreen}
//                 sx={{
//                   color: COLORS.text,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <FullscreenIcon />
//               </IconButton>
//             </Tooltip>

//             <Box
//               onClick={handleProfileMenuOpen}
//               sx={{
//                 display: { xs: "none", sm: "flex" },
//                 alignItems: "center",
//                 gap: 1,
//                 color: COLORS.text,
//                 fontSize: "14px",
//                 padding: "6px 12px",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//                 "&:hover": { background: COLORS.hoverBg },
//               }}
//             >
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   background: COLORS.accent,
//                   fontSize: "14px",
//                   fontWeight: 700,
//                 }}
//               >
//                 {userName.charAt(0).toUpperCase()}
//               </Avatar>
//               <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
//               <ExpandMoreIcon sx={{ fontSize: "18px" }} />
//             </Box>

//             {/* Profile Menu */}
//             <Menu
//               anchorEl={profileAnchor}
//               open={Boolean(profileAnchor)}
//               onClose={handleProfileMenuClose}
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               transformOrigin={{ vertical: "top", horizontal: "right" }}
//               PaperProps={{
//                 sx: {
//                   background: COLORS.primary,
//                   border: `1px solid ${COLORS.border}`,
//                   borderRadius: "8px",
//                   mt: 1,
//                 },
//               }}
//             >
//               <MenuItem
//                 sx={{
//                   color: COLORS.text,
//                   padding: "12px 20px",
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     width: 28,
//                     height: 28,
//                     background: COLORS.accent,
//                     mr: 1.5,
//                     fontSize: "12px",
//                   }}
//                 >
//                   {userName.charAt(0).toUpperCase()}
//                 </Avatar>
//                 {userName}
//               </MenuItem>

//               <MenuItem
//                 sx={{
//                   color: COLORS.textSecondary,
//                   fontSize: "12px",
//                   padding: "4px 20px",
//                   "&:hover": { background: "transparent" },
//                 }}
//               >
//                 HR Manager
//               </MenuItem>

//               <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

//               <MenuItem
//                 onClick={handleLogOut}
//                 sx={{
//                   color: COLORS.accent,
//                   padding: "12px 20px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <LogoutIcon sx={{ fontSize: "18px" }} />
//                 Logout
//               </MenuItem>
//             </Menu>
//           </Stack>
//         </Toolbar>
//       </StyledAppBar>

//       {/* Drawer */}
//       <StyledDrawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ minHeight: "70px", 
//                             borderBottom: `1px solid ${COLORS.border}`,
//                             display: "flex",
//                             flexDirection: "column", // 🔥 IMPORTANT
//                             alignItems: "stretch",
//                             padding: 0, }}>
//           {open && isAuthenticated &&(
//           <>
//           {/* User Welcome Section */}
//             <Box
//             sx={{
//               backgroundColor: "white",
//               padding: "15px",
//               borderRadius: "8px",
//               margin: "10px",
//               textAlign: "center",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               borderBottom: `1px solid ${COLORS.border}`,
//             }}
//             >
//             <Avatar
//               sx={{
//                 width: 50,
//                 height: 50,
//                 background: COLORS.accent,
//                 fontSize: "18px",
//                 fontWeight: 700,
//                 mb: 1,
//               }}
//             >
//               {userName.charAt(0).toUpperCase()}
//             </Avatar>

//             <Tooltip title={`${user?.name || ""}`} placement="right">
//               <Typography
//                 sx={{
//                   fontSize: "13px",
//                   fontWeight: "bold",
//                   color: "#1E1E1E",
//                   maxWidth: "160px",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 Welcome {userName}
//               </Typography>
//             </Tooltip>

//             <Typography
//               sx={{
//                 fontSize: "11px",
//                 color: COLORS.textSecondary,
//                 mt: 0.5,
//               }}
//             >
//               HR Manager
//             </Typography>
//            </Box>

//            {/* #naviagtion */}
//             <Box sx={{ pr: 2, width: "100%" }}>
//               <Typography
//                 sx={{
//                   fontSize: "11px",
//                   fontWeight: 700,
//                   color: COLORS.accent,
//                   textTransform: "uppercase",
//                   letterSpacing: "1.5px",
//                   mb: 1,
//                 }}
//               >
//                 Navigation
//               </Typography>
//             </Box>
//           </>
//           )}
//         </DrawerHeader>


//         {/* Navigation List */}
//         <List sx={{ color: COLORS.text, flex: 1 }}>
//           {menuItems.map((item) => (
//             <ListItem key={item.key} disablePadding>
//               <ListItemButton
//                 onClick={() => handleListItemClick(item.key)}
//                 sx={{
//                   minHeight: 48,
//                   justifyContent: open ? "initial" : "center",
//                   px: 2.5,
//                   "&:hover": {
//                     background: COLORS.hoverBg,
//                     color: COLORS.accent,
//                   },
//                   color: menudata === item.key ? COLORS.accent : COLORS.text,
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: 0,
//                     mr: open ? 3 : "auto",
//                     justifyContent: "center",
//                     color: "inherit",
//                   }}
//                 >
//                   <item.icon sx={{ fontSize: "22px" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.label}
//                   sx={{
//                     opacity: open ? 1 : 0,
//                     fontSize: "14px",
//                     "& .MuiTypography-root": {
//                       fontSize: "14px",
//                       fontWeight: menudata === item.key ? 600 : 500,
//                     },
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>

//         {/* Bottom Divider */}
//         <Divider sx={{ borderColor: COLORS.border }} />

//         {/* Bottom Actions */}
//         {open && (
//           <Box
//             sx={{
//               p: 2,
//               display: "flex",
//               flexDirection: "column",
//               gap: 1,
//             }}
//           >
//             <Box
//               onClick={handleLogOut}
//               sx={{
//                 color: COLORS.accent,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 justifyContent: "flex-start",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 padding: "10px 12px",
//                 borderRadius: "6px",
//                 border: `1px solid ${COLORS.border}`,
//                 cursor: "pointer",
//                 transition: "all 0.2s ease",
//                 "&:hover": {
//                   background: COLORS.hoverBg,
//                   borderColor: COLORS.accent,
//                 },
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: "18px" }} />
//               Logout
//             </Box>
//           </Box>
//         )}
//       </StyledDrawer>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           minHeight: "100vh",
//           background: COLORS.background,
//           overflow: "auto",
//           // marginTop: "70px",
//         }}
//       >
//         {/* Dashboard */}
//         {menudata === "Dashboard" && <HRcandidate />}

//         {/* Candidate Feedback */}
//         {menudata === "Candidate FeedBack" && <HRTable />}

//         {/* Manage Jobs */}
//         {menudata === "Manage Jobs" && (
//           <JobDescriptionManagementList
//             onOpenJobDescription={handleOpenCreateNewJob}
//           />
//         )}

//         {/* Create New Job */}
//         {showCreateNewJob && <JobDescription />}

//         {/* Schedule Interview */}
//         {showScheduleInterview && (
//           <ScheduleInterview onClose={handleCloseScheduleInterview} />
//         )}

//         {/* Interviews */}
//         {menudata === "Interviews" && <InterviewsTable />}

//         {/* Zoom Records */}
//         {menudata === "Zoom Records" && <ZoomMeeting />}
//       </Box>
//     </Box>
//   );
// };

// export default HRLandingPage;









































import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Drawer as MuiDrawer,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Stack,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  Work as WorkIcon,
  Event as EventIcon,
  CalendarMonth as CalendarIcon,
  Videocam as VideoIcon,
  Logout as LogoutIcon,
  ExpandMore as ExpandMoreIcon,
  Fullscreen as FullscreenIcon,
  ArrowBack as ArrowBackIcon,
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
} from "@mui/icons-material";

import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/slices/authSlice";
import { CapitalizeName } from "../../../utils/capitalizeName";
import createInstance from "../../../api/axiosinstance";

// Components
import HRcandidate from "../HRcandidate";
import HRTable from "../HRcandidate/HRTable";
import JobDescription from "../../organization/JobDescription";
import JobDescriptionManagementList from "../../organization/JobDescriptionManagementList";
import ScheduleInterview from "../ScheduleInterview";
import InterviewsTable from "../InterviewsTable";
import ZoomMeeting from "../Zoom";

const drawerWidth = 300;

// ==================== MAIN COMPONENT ====================
const HRLandingPage = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const aiDisha = createInstance("DISHA");
  const organizationId = user?.organizationId;
  const userName = CapitalizeName(user?.name || "");
  const { COLORS, theme, toggleTheme } = useThemeMode();

  // State Management
  const [menudata, setMenudata] = useState("Dashboard");
  const [titleText, setTitleText] = useState("HR Dashboard");
  const [open, setOpen] = useState(true);
  const [showCreateNewJob, setShowCreateNewJob] = useState(false);
  const [showScheduleInterview, setShowScheduleInterview] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState(null);

  // Menu Configuration
  const menuItems = [
    { label: "Dashboard", icon: HomeIcon, key: "Dashboard" },
    { label: "Candidate Feedback", icon: PersonIcon, key: "Candidate FeedBack" },
    { label: "Manage Jobs", icon: WorkIcon, key: "Manage Jobs" },
    { label: "Schedule Interview", icon: EventIcon, key: "Schedule Interview" },
    { label: "Interviews", icon: CalendarIcon, key: "Interviews" },
    { label: "Zoom Records", icon: VideoIcon, key: "Zoom Records" },
  ];

  // Fetch Dashboard Data
  useEffect(() => {
    Dashboard();
  }, [organizationId]);

  const Dashboard = async () => {
    try {
      const response = await aiDisha.get(
        `/hr_dashboard?organization_id=${organizationId}`
      );
      console.log("dashboard", response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  // Event Handlers
  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleListItemClick = (item) => {
    if (item === "Schedule Interview") {
      handleOpenScheduleInterview();
    } else {
      setMenudata(item);
      setTitleText(item === "Dashboard" ? "HR Dashboard" : item);
      setShowCreateNewJob(false);
      setShowScheduleInterview(false);
    }
  };

  const handleOpenCreateNewJob = () => {
    setMenudata("");
    setTitleText("Create New Job");
    setShowCreateNewJob(true);
    setShowScheduleInterview(false);
  };

  const handleOpenScheduleInterview = () => {
    setMenudata("");
    setTitleText("Schedule Interview");
    setShowScheduleInterview(true);
    setShowCreateNewJob(false);
  };

  const handleCloseScheduleInterview = () => {
    setShowScheduleInterview(false);
    setMenudata("Dashboard");
    setTitleText("HR Dashboard");
  };

  const handleProfileMenuOpen = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchor(null);
  };

  const handleLogOut = () => {
    handleProfileMenuClose();
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    setTimeout(() => navigate("/"), 0);
  };

  const handleFullscreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };

  // Create styled components inside component with access to COLORS
  const StyledDrawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme: muiTheme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      width: drawerWidth,
      transition: muiTheme.transitions.create("width", {
        easing: muiTheme.transitions.easing.sharp,
        duration: muiTheme.transitions.duration.enteringScreen,
      }),
      overflowX: "hidden",
      "& .MuiDrawer-paper": {
        width: drawerWidth,
        transition: muiTheme.transitions.create("width", {
          easing: muiTheme.transitions.easing.sharp,
          duration: muiTheme.transitions.duration.enteringScreen,
        }),
        overflowX: "hidden",
        background: COLORS.secondary,
        borderRight: `1px solid ${COLORS.border}`,
      },
    }),
    ...(!open && {
      transition: muiTheme.transitions.create("width", {
        easing: muiTheme.transitions.easing.sharp,
        duration: muiTheme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: `calc(${muiTheme.spacing(7)} + 1px)`,
      [muiTheme.breakpoints.up("sm")]: {
        width: `calc(${muiTheme.spacing(8)} + 1px)`,
      },
      "& .MuiDrawer-paper": {
        transition: muiTheme.transitions.create("width", {
          easing: muiTheme.transitions.easing.sharp,
          duration: muiTheme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: `calc(${muiTheme.spacing(7)} + 1px)`,
        [muiTheme.breakpoints.up("sm")]: {
          width: `calc(${muiTheme.spacing(8)} + 1px)`,
        },
        background: COLORS.secondary,
        borderRight: `1px solid ${COLORS.border}`,
      },
    }),
  }));

  const StyledAppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme: muiTheme, open }) => ({
    background: COLORS.primary,
    borderBottom: `1px solid ${COLORS.border}`,
    zIndex: muiTheme.zIndex.drawer + 1,
    transition: muiTheme.transitions.create(["width", "margin"], {
      easing: muiTheme.transitions.easing.sharp,
      duration: muiTheme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: muiTheme.transitions.create(["width", "margin"], {
        easing: muiTheme.transitions.easing.sharp,
        duration: muiTheme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const DrawerHeader = styled("div")(({ theme: muiTheme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: muiTheme.spacing(0, 1),
    ...muiTheme.mixins.toolbar,
  }));

  if (!isAuthenticated || user?.role !== "HR") {
    navigate("/");
    return null;
  }

  return (
    <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
      {/* AppBar */}
      <StyledAppBar position="fixed" open={open}>
        <Toolbar sx={{ minHeight: "80px !important", display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
              color="inherit"
              aria-label="toggle drawer"
              onClick={handleDrawerToggle}
              edge="start"
              sx={{ color: COLORS.accent }}
            >
              {open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: COLORS.text,
                letterSpacing: "0.5px",
              }}
            >
              {titleText}
            </Typography>
          </Box>

          {/* Right Side Actions */}
          <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title={`Switch to ${theme === "light" ? "Dark" : "Light"} Mode`}>
              <IconButton
                onClick={toggleTheme}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                {theme === "light" ? <DarkModeIcon /> : <LightModeIcon />}
              </IconButton>
            </Tooltip>

            <Tooltip title="Fullscreen Mode (F11)">
              <IconButton
                onClick={handleFullscreen}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <FullscreenIcon />
              </IconButton>
            </Tooltip>

            <Box
              onClick={handleProfileMenuOpen}
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
                color: COLORS.text,
                fontSize: "14px",
                padding: "6px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                "&:hover": { background: COLORS.hoverBg },
              }}
            >
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  background: COLORS.accent,
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {userName.charAt(0).toUpperCase()}
              </Avatar>
              <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
              <ExpandMoreIcon sx={{ fontSize: "18px" }} />
            </Box>

            {/* Profile Menu */}
            <Menu
              anchorEl={profileAnchor}
              open={Boolean(profileAnchor)}
              onClose={handleProfileMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  background: COLORS.primary,
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: "8px",
                  mt: 1,
                },
              }}
            >
              <MenuItem
                sx={{
                  color: COLORS.text,
                  padding: "12px 20px",
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    background: COLORS.accent,
                    mr: 1.5,
                    fontSize: "12px",
                  }}
                >
                  {userName.charAt(0).toUpperCase()}
                </Avatar>
                {userName}
              </MenuItem>

              <MenuItem
                sx={{
                  color: COLORS.textSecondary,
                  fontSize: "12px",
                  padding: "4px 20px",
                  "&:hover": { background: "transparent" },
                }}
              >
                HR Manager
              </MenuItem>

              <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

              <MenuItem
                onClick={handleLogOut}
                sx={{
                  color: COLORS.accent,
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <LogoutIcon sx={{ fontSize: "18px" }} />
                Logout
              </MenuItem>
            </Menu>
          </Stack>
        </Toolbar>
      </StyledAppBar>

      {/* Drawer */}
      <StyledDrawer variant="permanent" open={open}>
        <DrawerHeader
          sx={{
            minHeight: "70px",
            borderBottom: `1px solid ${COLORS.border}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            padding: 0,
          }}
        >
          {open && isAuthenticated && (
            <>
              {/* User Welcome Section */}
              <Box
                sx={{
                  backgroundColor: COLORS.primary,
                  padding: "15px",
                  borderRadius: "8px",
                  margin: "10px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderBottom: `1px solid ${COLORS.border}`,
                }}
              >
                <Avatar
                  sx={{
                    width: 50,
                    height: 50,
                    background: COLORS.accent,
                    fontSize: "18px",
                    fontWeight: 700,
                    mb: 1,
                  }}
                >
                  {userName.charAt(0).toUpperCase()}
                </Avatar>

                <Tooltip title={`${user?.name || ""}`} placement="right">
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: COLORS.text,
                      maxWidth: "160px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Welcome {userName}
                  </Typography>
                </Tooltip>

                <Typography
                  sx={{
                    fontSize: "11px",
                    color: COLORS.textSecondary,
                    mt: 0.5,
                  }}
                >
                  HR Manager
                </Typography>
              </Box>

              {/* #navigation */}
              <Box sx={{ pr: 2, width: "100%" }}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: COLORS.accent,
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                    mb: 1,
                  }}
                >
                  Navigation
                </Typography>
              </Box>
            </>
          )}
        </DrawerHeader>

        {/* Navigation List */}
        <List sx={{ color: COLORS.text, flex: 1 }}>
          {menuItems.map((item) => (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                onClick={() => handleListItemClick(item.key)}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    background: COLORS.hoverBg,
                    color: COLORS.accent,
                  },
                  color: menudata === item.key ? COLORS.accent : COLORS.text,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "inherit",
                  }}
                >
                  <item.icon sx={{ fontSize: "22px" }} />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    opacity: open ? 1 : 0,
                    fontSize: "14px",
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      fontWeight: menudata === item.key ? 600 : 500,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {/* Bottom Divider */}
        <Divider sx={{ borderColor: COLORS.border }} />

        {/* Bottom Actions */}
        {open && (
          <Box
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box
              onClick={handleLogOut}
              sx={{
                color: COLORS.accent,
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "flex-start",
                textTransform: "none",
                fontSize: "14px",
                padding: "10px 12px",
                borderRadius: "6px",
                border: `1px solid ${COLORS.border}`,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  background: COLORS.hoverBg,
                  borderColor: COLORS.accent,
                },
              }}
            >
              <LogoutIcon sx={{ fontSize: "18px" }} />
              Logout
            </Box>
          </Box>
        )}
      </StyledDrawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          minHeight: "100vh",
          background: COLORS.background,
          overflow: "auto",
        }}
      >
        {/* Dashboard */}
        {menudata === "Dashboard" && <HRcandidate />}

        {/* Candidate Feedback */}
        {menudata === "Candidate FeedBack" && <HRTable />}

        {/* Manage Jobs */}
        {menudata === "Manage Jobs" && (
          <JobDescriptionManagementList
            onOpenJobDescription={handleOpenCreateNewJob}
          />
        )}

        {/* Create New Job */}
        {showCreateNewJob && <JobDescription />}

        {/* Schedule Interview */}
        {showScheduleInterview && (
          <ScheduleInterview onClose={handleCloseScheduleInterview} />
        )}

        {/* Interviews */}
        {menudata === "Interviews" && <InterviewsTable />}

        {/* Zoom Records */}
        {menudata === "Zoom Records" && <ZoomMeeting />}
      </Box>
    </Box>
  );
};

export default HRLandingPage;